import isEmpty from 'lodash/isEmpty';
import { useTemplateContext } from 'modules/campaigns/editor/context';
import { SMSPrimaryContent } from 'modules/campaigns/editor/types';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

import { LightText, StyledNewTabLink } from '../Sections.styled';

export const SMSContent = () => {
  const { templateAndContent, contactCardName } = useTemplateContext();
  const { primaryContent = {} } = templateAndContent;
  const { message: smsMessage, imageUrl } = primaryContent as SMSPrimaryContent;

  return (
    <>
      <CampaignFormField labelText="Message">
        <ReadOnlyField name="message">{smsMessage || <LightText>Not set</LightText>}</ReadOnlyField>
      </CampaignFormField>

      <CampaignFormField labelText="Media URL">
        <ReadOnlyField name="mediaUrl">
          {!isEmpty(imageUrl) ? (
            <StyledNewTabLink href={imageUrl}>{imageUrl}</StyledNewTabLink>
          ) : (
            <LightText>Not set</LightText>
          )}
        </ReadOnlyField>
      </CampaignFormField>

      <CampaignFormField labelText="Contact cards">
        <ReadOnlyField name="contactCard">
          {contactCardName || <LightText>Not set</LightText>}
        </ReadOnlyField>
      </CampaignFormField>
    </>
  );
};
